// import React, { useEffect, useMemo, useState, useContext } from "react";
// import { toCommas } from "../../utils/utils";
// import styles from "./Dashboard.module.css";
// import { useHistory, useLocation, Link } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { getInvoices } from "../../actions/invoiceActions";
// import { getMeetings } from "../../actions/meetingActions";
// import {
//   MuiPickersUtilsProvider,
//   KeyboardDatePicker,
// } from "@material-ui/pickers";
// import DateFnsUtils from "@date-io/date-fns";
// import {
//   Button,
//   Collapse,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
// } from "@material-ui/core";
// import ReplayIcon from "@material-ui/icons/Replay";
// import moment from "moment";
// import { Check, Report, Order } from "./Icons";
// import Spinner from "../Spinner/Spinner";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
// } from "recharts";
// import { StockContext } from "../../Context/StockContext";
// import * as api from "../../api/index";
// import axios from "axios";
// import { getStockAdjustments } from "../../actions/stockAdjustmentActions";

// const Dashboard = () => {
//   const location = useLocation();
//   const history = useHistory();
//   const dispatch = useDispatch();
//   const user = JSON.parse(localStorage.getItem("profile"));
//   const { invoices, isLoading } = useSelector((state) => state?.invoices);
//   const { meetings } = useSelector((state) => state?.meetings);
//   const { items } = useSelector((state) => state.items);
//   const { getCurrentStockQty, getConvertedQuantity, convertPrice } =
//     useContext(StockContext);
//   const [lowStockItems, setLowStockItems] = useState([]);
//   const [showLowStock, setShowLowStock] = useState(false);
//   const [startDate, setStartDate] = useState(new Date());
//   const [endDate, setEndDate] = useState(new Date());
//   const [totalCreditDue, setTotalCreditDue] = useState(0);
//   const [salesView, setSalesView] = useState("month");
//   const [stockValuation, setStockValuation] = useState(0);
//   const [showAllSales, setShowAllSales] = useState(false);
//   const stockAdjustments = useSelector(
//     (state) => state.stockAdjustments.stockAdjustments
//   );
//   // Date filter handlers
//   const handleStartDateChange = (date) => {
//     if (date && (!endDate || date <= endDate)) setStartDate(date);
//   };

//   const handleEndDateChange = (date) => {
//     if (date && (!startDate || date >= startDate)) setEndDate(date);
//   };

//   const handleResetFilters = () => {
//     const today = new Date();
//     setStartDate(today);
//     setEndDate(today);
//   };

//   // Fetch low stock items
//   useEffect(() => {
//     const fetchLowStockItems = async () => {
//       try {
//         const { data: items } = await api.fetchItems();
//         const lowStock = [];
//         for (const item of items) {
//           if (
//             !item ||
//             !item._id ||
//             !item.itemName ||
//             !item.stockQty?.minQty ||
//             !item.toggleStock ||
//             !item.isActive ||
//             item.isDeleted
//           ) {
//             continue;
//           }
//           const stockData = await getCurrentStockQty(item._id);
//           if (stockData && stockData.currentStock <= item.stockQty.minQty) {
//             lowStock.push({
//               _id: item._id,
//               name: item.itemName,
//               currentStock: stockData.currentStock,
//               minStock: item.stockQty.minQty,
//               unit: item.units?.stock?.unit?.abbreviation || "",
//             });
//           }
//         }
//         setLowStockItems(lowStock);
//       } catch (error) {
//         console.error("Error fetching low stock items:", error);
//         setLowStockItems([]);
//       }
//     };
//     fetchLowStockItems();
//   }, [getCurrentStockQty]);

//   // Fetch purchases and calculate total credit due
//   useEffect(() => {
//     const fetchPurchases = async () => {
//       try {
//         const { data: purchases } = await axios.get(
//           `${process.env.REACT_APP_API}/purchases?searchQuery=${user?.result?._id}`
//         );
//         const creditDue = purchases
//           .filter((purchase) => purchase.paymentMode === "Credit")
//           .reduce((sum, purchase) => sum + (purchase.supplierDue || 0), 0);
//         setTotalCreditDue(creditDue);
//       } catch (error) {
//         console.error("Error fetching purchases:", error);
//         setTotalCreditDue(0);
//       }
//     };
//     if (user?.result?._id) {
//       fetchPurchases();
//     }
//   }, [user?.result?._id]);

//   // Fetch invoices and meetings
//   useEffect(() => {
//     dispatch(getInvoices());
//     dispatch(getMeetings());
//     dispatch(getStockAdjustments());
//   }, [location, dispatch]);

//   //   useEffect(() => {
//   //     console.log("Stock Adjustments ------------:", stockAdjustments);
//   //   }, [stockAdjustments]);

//   useEffect(() => {
//     console.log("invoices Data ------------:", invoices);
//   }, [invoices]);

//   useEffect(() => {
//     const calculateStockValuation = async () => {
//       try {
//         const { data: allItems } = await api.fetchItems();
//         const stockItems = allItems.filter(
//           (item) => item.toggleStock && item.isActive && !item.isDeleted
//         );

//         let totalValuation = 0;

//         for (const item of stockItems) {
//           const stockData = await getCurrentStockQty(item._id);
//           const currentStock = stockData?.currentStock || 0;

//           console.log(`Item: ${item.itemName}, Current Stock: ${currentStock}`);

//           if (currentStock <= 0) continue;

//           // Fetch purchases
//           const { data: purchases } = await axios.get(
//             `${process.env.REACT_APP_API}/purchases?searchQuery=${user?.result?._id}`
//           );

//           console.log(`Raw purchase data for ${item.itemName}:`, purchases);

//           const itemPurchases = purchases
//             .filter((purchase) => {
//               if (!purchase.items) return false;
//               return purchase.items.some((purchaseItem) => {
//                 const purchaseItemId = purchaseItem.item?._id?.toString();
//                 return purchaseItemId === item._id.toString();
//               });
//             })
//             .map((purchase) => ({
//               date: moment(purchase.createdAt),
//               items: purchase.items
//                 .filter(
//                   (purchaseItem) =>
//                     purchaseItem.item?._id?.toString() === item._id.toString()
//                 )
//                 .map((purchaseItem) => ({
//                   item: purchaseItem.item,
//                   quantity: parseFloat(purchaseItem.quantity || 0),
//                   cost: parseFloat(purchaseItem.cost || 0),
//                   providedCost: null,
//                 })),
//               isInitial: false,
//               isAdjustment: false,
//             }));

//           console.log(`Item Purchases for ${item.itemName}:`, itemPurchases);

//           // Process stock adjustments
//           const itemAdjustments = stockAdjustments
//             .filter((adjustment) => {
//               if (!adjustment.items) return false;
//               return adjustment.items.some(
//                 (adjItem) => adjItem.item?.toString() === item._id.toString()
//               );
//             })
//             .map((adjustment) => {
//               const adjItem = adjustment.items.find(
//                 (adjItem) => adjItem.item?.toString() === item._id.toString()
//               );
//               const qty = parseFloat(adjItem.quantity || 0);
//               const isAdd = adjustment.adjustType === "Add";
//               let adjustmentCost = isAdd ? parseFloat(adjItem.cost || 0) : 0;

//               // For Add adjustments, if no cost, use sale price converted to purchase unit
//               if (isAdd && (!adjustmentCost || isNaN(adjustmentCost))) {
//                 const salePrice = parseFloat(item.units?.sale?.price || 0);
//                 if (salePrice > 0) {
//                   const saleUnitId = String(item.units?.sale?.unit?._id);
//                   const purchaseUnitId = String(
//                     item.units?.purchase?.unit?._id ||
//                       item.units?.stock?.unit?._id
//                   );
//                   adjustmentCost = convertPrice(
//                     { price: salePrice, units: item.units },
//                     saleUnitId,
//                     purchaseUnitId
//                   );
//                   console.log(
//                     `Adjustment (Add) for ${item.itemName}: No cost provided. Using sale price: ` +
//                       `Sale Price = ${salePrice} (${saleUnitId}), ` +
//                       `Converted to ${purchaseUnitId} = ${adjustmentCost}, ` +
//                       `Processed as purchase`
//                   );
//                 } else {
//                   adjustmentCost = 0;
//                   console.warn(
//                     `Adjustment (Add) for ${item.itemName}: No cost or sale price. Setting cost to 0, Processed as purchase`
//                   );
//                 }
//               } else if (isAdd) {
//                 console.log(
//                   `Adjustment (Add) for ${item.itemName}: Cost provided: ${adjustmentCost}, Processed as purchase`
//                 );
//               }

//               // Log provided cost for Deduct adjustments (ignored for all calculations)
//               if (!isAdd && adjItem.cost) {
//                 console.log(
//                   `Adjustment (Deduct) for ${item.itemName}: Provided cost ${adjItem.cost} recorded but ignored for valuation and deducted cost, Processed as sale`
//                 );
//               } else if (!isAdd) {
//                 console.log(
//                   `Adjustment (Deduct) for ${item.itemName}: No cost provided, Processed as sale with cost 0 for valuation`
//                 );
//               }

//               return {
//                 date: moment(adjustment.createdAt),
//                 items: [
//                   {
//                     item: { _id: item._id },
//                     quantity: isAdd ? qty : -qty,
//                     cost: adjustmentCost,
//                     providedCost: adjItem.cost
//                       ? parseFloat(adjItem.cost)
//                       : null,
//                   },
//                 ],
//                 isInitial: false,
//                 isAdjustment: true,
//               };
//             });

//           console.log(
//             `Item Adjustments for ${item.itemName}:`,
//             itemAdjustments
//           );

//           // Calculate initial cost
//           let initialCost = parseFloat(item.units?.purchase?.cost || 0);
//           if (!initialCost || isNaN(initialCost)) {
//             const salePrice = parseFloat(item.units?.sale?.price || 0);
//             if (salePrice > 0) {
//               const saleUnitId = String(item.units?.sale?.unit?._id);
//               const purchaseUnitId = String(
//                 item.units?.purchase?.unit?._id || item.units?.stock?.unit?._id
//               );
//               initialCost = convertPrice(
//                 { price: salePrice, units: item.units },
//                 saleUnitId,
//                 purchaseUnitId
//               );
//               console.log(
//                 `Item: ${item.itemName}, No initial cost. Using sale price: ` +
//                   `Sale Price = ${salePrice} (${saleUnitId}), ` +
//                   `Converted to ${purchaseUnitId} = ${initialCost}, ` +
//                   `Cost = ${initialCost}`
//               );
//             } else {
//               initialCost = 0;
//               console.warn(
//                 `Item: ${item.itemName}, No initial cost or sale price. Setting cost to 0`
//               );
//             }
//           }

//           const initialPurchase = {
//             date: moment(item.createdAt),
//             items: [
//               {
//                 item: { _id: item._id },
//                 quantity: parseFloat(item.stockQty?.initialQty || 0),
//                 cost: initialCost,
//                 providedCost: null,
//               },
//             ],
//             isInitial: true,
//             isAdjustment: false,
//           };

//           const allPurchaseEntries = [
//             initialPurchase,
//             ...itemPurchases,
//             ...itemAdjustments,
//           ].sort((a, b) => {
//             if (a.date.isSame(b.date)) {
//               return a.isInitial ? -1 : a.isAdjustment ? 0 : 1;
//             }
//             return a.date.isBefore(b.date) ? -1 : 1;
//           });

//           console.log(
//             `Sorted Purchase Entries for ${item.itemName}:`,
//             allPurchaseEntries.map((entry) => ({
//               date: entry.date.format("YYYY-MM-DD HH:mm:ss"),
//               items: entry.items.map((item) => ({
//                 quantity: item.quantity,
//                 cost: item.cost,
//                 providedCost: item.providedCost,
//               })),
//               isInitial: entry.isInitial,
//               isAdjustment: entry.isAdjustment,
//             }))
//           );

//           const totalPurchased = allPurchaseEntries.reduce(
//             (sum, entry) =>
//               sum +
//               entry.items.reduce(
//                 (s, item) => s + parseFloat(item.quantity || 0),
//                 0
//               ),
//             0
//           );
//           console.log(
//             `Total Purchased Stock for ${item.itemName}: ${totalPurchased}`
//           );

//           let itemValuation = 0;
//           let deductedCostTotal = 0;

//           // Check for Deduct adjustments and sales
//           let deductUnitsTotal = 0;
//           let saleUnitsTotal = totalPurchased - currentStock;

//           for (const entry of allPurchaseEntries) {
//             for (const entryItem of entry.items) {
//               const qty = parseFloat(entryItem.quantity || 0);
//               if (qty < 0 && entry.isAdjustment) {
//                 deductUnitsTotal += Math.abs(qty);
//               }
//             }
//           }

//           const totalSold =
//             deductUnitsTotal + (saleUnitsTotal > 0 ? saleUnitsTotal : 0);

//           if (
//             Math.abs(currentStock - totalPurchased) < 0.01 &&
//             deductUnitsTotal === 0
//           ) {
//             // No sales or deductions, use all positive entries
//             for (const entry of allPurchaseEntries) {
//               for (const entryItem of entry.items) {
//                 const qty = parseFloat(entryItem.quantity || 0);
//                 const cost = parseFloat(entryItem.cost || 0);

//                 if (qty <= 0 || cost <= 0) continue;

//                 const value = qty * cost;
//                 itemValuation += value;

//                 console.log(
//                   `Valuation for ${item.itemName} (No Sales or Deductions): Using ${qty} units @ ${cost} = ${value}, ` +
//                     `From ${
//                       entry.isInitial
//                         ? "Initial"
//                         : entry.isAdjustment
//                         ? "Adjustment (Add)"
//                         : "Purchase"
//                     }`
//                 );
//               }
//             }
//           } else {
//             // Simulate FIFO removal for sales and deductions
//             let remainingStock = [];
//             let soldUnits = 0;
//             let deductUnitsPending = deductUnitsTotal;
//             let saleUnitsPending = saleUnitsTotal;

//             console.log(
//               `Simulating ${totalSold} units sold/deducted for ${item.itemName} (Deduct: ${deductUnitsTotal}, Sales: ${saleUnitsTotal})`
//             );

//             // Process positive quantities to build remainingStock in FIFO order
//             for (const entry of allPurchaseEntries) {
//               for (const entryItem of entry.items) {
//                 const qty = parseFloat(entryItem.quantity || 0);
//                 const cost = parseFloat(entryItem.cost || 0);
//                 const providedCost = entryItem.providedCost;

//                 if (qty === 0) continue;

//                 if (qty > 0) {
//                   // Handle deductions first, then sales
//                   let qtyToSell = 0;

//                   // Deduct adjustments
//                   if (deductUnitsPending > 0) {
//                     const deductQty = Math.min(deductUnitsPending, qty);
//                     qtyToSell += deductQty;
//                     deductUnitsPending -= deductQty;
//                     soldUnits += deductQty;

//                     console.log(
//                       `Simulating Deduction for ${
//                         item.itemName
//                       }: Removed ${deductQty} units @ ${cost} = ${
//                         deductQty * cost
//                       }, ` +
//                         `Remaining in this batch: ${
//                           qty - qtyToSell
//                         }, Total Removed: ${soldUnits}, ` +
//                         `From ${
//                           entry.isInitial
//                             ? "Initial"
//                             : entry.isAdjustment
//                             ? "Adjustment (Add)"
//                             : "Purchase"
//                         }`
//                     );

//                     deductedCostTotal += deductQty * cost;
//                   }

//                   // Sales
//                   if (saleUnitsPending > 0 && soldUnits < totalSold) {
//                     const saleQty = Math.min(saleUnitsPending, qty - qtyToSell);
//                     qtyToSell += saleQty;
//                     saleUnitsPending -= saleQty;
//                     soldUnits += saleQty;

//                     console.log(
//                       `Simulating Sale for ${
//                         item.itemName
//                       }: Removed ${saleQty} units @ ${cost} = ${
//                         saleQty * cost
//                       }, ` +
//                         `Remaining in this batch: ${
//                           qty - qtyToSell
//                         }, Total Removed: ${soldUnits}, ` +
//                         `From ${
//                           entry.isInitial
//                             ? "Initial"
//                             : entry.isAdjustment
//                             ? "Adjustment (Add)"
//                             : "Purchase"
//                         }`
//                     );

//                     deductedCostTotal += saleQty * cost;
//                   }

//                   const qtyRemaining = qty - qtyToSell;

//                   if (qtyRemaining > 0) {
//                     remainingStock.push({
//                       quantity: qtyRemaining,
//                       cost: cost,
//                       isInitial: entry.isInitial,
//                       isAdjustment: entry.isAdjustment,
//                     });
//                   }
//                 } else if (qty < 0 && soldUnits < totalSold) {
//                   // Deduct adjustments (already counted in deductUnitsTotal)
//                   const qtyToSell = Math.min(
//                     totalSold - soldUnits,
//                     Math.abs(qty)
//                   );
//                   soldUnits += qtyToSell;
//                   const qtyRemaining = Math.abs(qty) - qtyToSell;

//                   // Use the cost of the earliest stock for deductions (same as sales)
//                   const deductionCost = cost; // Use the cost of the stock being deducted
//                   deductedCostTotal += qtyToSell * deductionCost;

//                   console.log(
//                     `Simulating Deduction for ${
//                       item.itemName
//                     }: Deducted ${qtyToSell} units @ ${deductionCost} = ${
//                       qtyToSell * deductionCost
//                     } (processed as sale, provided cost: ${
//                       providedCost !== null ? providedCost : "none"
//                     } ignored), ` +
//                       `Remaining in this batch: ${qtyRemaining}, Total Removed: ${soldUnits}, ` +
//                       `From Adjustment (Deduct)`
//                   );

//                   if (qtyRemaining > 0) {
//                     remainingStock.push({
//                       quantity: -qtyRemaining,
//                       cost: 0,
//                       isInitial: false,
//                       isAdjustment: true,
//                     });
//                   }
//                 }
//               }
//             }

//             console.log(
//               `Total cost of deducted/sold stock for ${item.itemName}: ${deductedCostTotal}`
//             );
//             console.log(
//               `Remaining Stock for ${item.itemName}:`,
//               remainingStock.map((stock) => ({
//                 quantity: stock.quantity,
//                 cost: stock.cost,
//                 isInitial: stock.isInitial,
//                 isAdjustment: stock.isAdjustment,
//               }))
//             );

//             let remainingToValue = currentStock;

//             for (const stock of remainingStock) {
//               const qty = parseFloat(stock.quantity || 0);
//               const cost = parseFloat(stock.cost || 0);

//               if (qty <= 0 || cost <= 0) continue;

//               const qtyToUse = Math.min(remainingToValue, qty);
//               if (qtyToUse <= 0) continue;

//               const value = qtyToUse * cost;
//               itemValuation += value;
//               remainingToValue -= qtyToUse;

//               console.log(
//                 `Valuation for ${item.itemName}: Using ${qtyToUse} units @ ${cost} = ${value}, ` +
//                   `From ${
//                     stock.isInitial
//                       ? "Initial"
//                       : stock.isAdjustment
//                       ? "Adjustment (Add)"
//                       : "Purchase"
//                   }, ` +
//                   `Remaining to value: ${remainingToValue}`
//               );

//               if (remainingToValue <= 0) break;
//             }

//             if (remainingToValue > 0) {
//               console.warn(
//                 `Valuation incomplete for ${item.itemName}: ${remainingToValue} units not valued`
//               );
//             }
//           }

//           console.log(`Item: ${item.itemName}, Valuation: ${itemValuation}`);
//           totalValuation += itemValuation;
//         }

//         console.log(`Total Valuation: ${totalValuation}`);
//         setStockValuation(totalValuation);
//       } catch (error) {
//         console.error("Error calculating stock valuation:", error);
//         setStockValuation(0);
//       }
//     };

//     if (user?.result?._id) {
//       calculateStockValuation();
//     }
//   }, [
//     user?.result?._id,
//     getCurrentStockQty,
//     getConvertedQuantity,
//     convertPrice,
//     stockAdjustments,
//   ]);

//   // Discount...
//   const totalDiscount = invoices
//     ? invoices
//         .filter((inv) =>
//           moment(inv.createdAt).isBetween(
//             moment(startDate).startOf("day"),
//             moment(endDate).endOf("day"),
//             null,
//             "[]"
//           )
//         )
//         .reduce((sum, inv) => sum + (inv.discount || 0), 0)
//     : 0;

//   // Financial calculations
//   const today = moment().startOf("day");
//   const isTodayFilter =
//     moment(startDate).isSame(today, "day") &&
//     moment(endDate).isSame(today, "day");



//   // Toggle See More/See Less
//   const toggleShowAllSales = () => {
//     setShowAllSales(!showAllSales);
//   };

//   const todaysSales = {
//     cashSale: invoices
//       ? invoices
//           .filter(
//             (inv) =>
//               moment(inv.createdAt).isBetween(
//                 moment(startDate).startOf("day"),
//                 moment(endDate).endOf("day"),
//                 null,
//                 "[]"
//               ) && inv.paymentMode === "Cash"
//           )
//           .reduce((sum, inv) => sum + (inv.total || 0), 0)
//       : 0,
//     onlineSale: invoices
//       ? invoices
//           .filter(
//             (inv) =>
//               moment(inv.createdAt).isBetween(
//                 moment(startDate).startOf("day"),
//                 moment(endDate).endOf("day"),
//                 null,
//                 "[]"
//               ) && inv.paymentMode === "Online"
//           )
//           .reduce((sum, inv) => sum + (inv.total || 0), 0)
//       : 0,
//     cardSale: invoices
//       ? invoices
//           .filter(
//             (inv) =>
//               moment(inv.createdAt).isBetween(
//                 moment(startDate).startOf("day"),
//                 moment(endDate).endOf("day"),
//                 null,
//                 "[]"
//               ) && inv.paymentMode === "Card"
//           )
//           .reduce((sum, inv) => sum + (inv.total || 0), 0)
//       : 0,
//     creditSale: invoices
//       ? invoices
//           .filter(
//             (inv) =>
//               moment(inv.createdAt).isBetween(
//                 moment(startDate).startOf("day"),
//                 moment(endDate).endOf("day"),
//                 null,
//                 "[]"
//               ) && inv.paymentMode === "Credit"
//           )
//           .reduce((sum, inv) => sum + (inv.total || 0), 0)
//       : 0,
//   };
//   todaysSales.totalSale =
//     todaysSales.cashSale +
//     todaysSales.onlineSale +
//     todaysSales.cardSale +
//     todaysSales.creditSale;

//   const cashFlow = {
//     receiptTotal: meetings
//       ? meetings
//           .filter(
//             (meeting) =>
//               moment(meeting.createdAt).isBetween(
//                 moment(startDate).startOf("day"),
//                 moment(endDate).endOf("day"),
//                 null,
//                 "[]"
//               ) && meeting.transactionType === "Receipt"
//           )
//           .reduce((sum, meeting) => sum + (meeting.payment || 0), 0)
//       : 0,
//     paymentsTotal: meetings
//       ? meetings
//           .filter(
//             (meeting) =>
//               moment(meeting.createdAt).isBetween(
//                 moment(startDate).startOf("day"),
//                 moment(endDate).endOf("day"),
//                 null,
//                 "[]"
//               ) && meeting.transactionType === "Payment"
//           )
//           .reduce((sum, meeting) => sum + (meeting.payment || 0), 0)
//       : 0,
//     netCashFlow:
//       (meetings
//         ? meetings
//             .filter(
//               (meeting) =>
//                 moment(meeting.createdAt).isBetween(
//                   moment(startDate).startOf("day"),
//                   moment(endDate).endOf("day"),
//                   null,
//                   "[]"
//                 ) && meeting.transactionType === "Receipt"
//             )
//             .reduce((sum, meeting) => sum + (meeting.payment || 0), 0)
//         : 0) -
//       (meetings
//         ? meetings
//             .filter(
//               (meeting) =>
//                 moment(meeting.createdAt).isBetween(
//                   moment(startDate).startOf("day"),
//                   moment(endDate).endOf("day"),
//                   null,
//                   "[]"
//                 ) && meeting.transactionType === "Payment"
//             )
//             .reduce((sum, meeting) => sum + (meeting.payment || 0), 0)
//         : 0),
//   };

//   const receivables = invoices
//     ? invoices
//         .filter(
//           (inv) =>
//             inv.paymentMode === "Credit" &&
//             ["Due", "Partial"].includes(inv.status) &&
//             moment(inv.createdAt).isSameOrBefore(moment(), "day")
//         )
//         .reduce((sum, inv) => {
//           if (inv.status === "Due") {
//             return sum + (inv.total || 0);
//           } else if (inv.status === "Partial") {
//             return sum + ((inv.total || 0) - (inv.totalAmountReceived || 0));
//           }
//           return sum;
//         }, 0)
//     : 0;

//   const payables = totalCreditDue;

//   // Fast and slow selling items
//   const { fastSelling, slowSelling } = useMemo(() => {
//     const salesMap = {};
//     invoices?.forEach((invoice) => {
//       if (!invoice || !invoice.items) return;
//       const uniqueItems = new Set();
//       invoice.items.forEach((invoiceItem) => {
//         if (!invoiceItem || !invoiceItem.item || !invoiceItem.item._id) return;
//         const itemId = invoiceItem.item._id;
//         if (!uniqueItems.has(itemId)) {
//           uniqueItems.add(itemId);
//           const itemName = invoiceItem.item.itemName || "Unknown Item";
//           const quantity = invoiceItem.quantity || 0;
//           const price = invoiceItem.item.units?.sale?.price || 0;

//           if (!salesMap[itemId]) {
//             salesMap[itemId] = {
//               id: itemId,
//               name: itemName,
//               appearances: 0,
//               quantity: 0,
//               amount: 0,
//             };
//           }
//           salesMap[itemId].appearances += 1;
//           salesMap[itemId].quantity += quantity;
//           salesMap[itemId].amount += quantity * price;
//         }
//       });
//     });

//     const itemsArray = Object.values(salesMap);
//     const fastSelling = itemsArray
//       .sort((a, b) => b.appearances - a.appearances || b.quantity - b.quantity)
//       .slice(0, 3)
//       .map((item) => ({ ...item, type: "Fast" }));
//     const slowSelling = itemsArray
//       .sort((a, b) => a.appearances - b.appearances || a.quantity - b.quantity)
//       .slice(0, 3)
//       .map((item) => ({ ...item, type: "Slow" }));

//     return { fastSelling, slowSelling };
//   }, [invoices]);

//   // YTD Sales Data
//   const ytdSalesData = useMemo(() => {
//     const currentYear = moment().year();
//     const previousYear = currentYear - 1;
//     const data = [];

//     if (salesView === "month") {
//       const currentMonth = moment().month();
//       for (let i = 0; i <= currentMonth; i++) {
//         const monthStartCurrent = moment([currentYear, i, 1]).startOf("month");
//         const monthEndCurrent = moment([currentYear, i, 1]).endOf("month");
//         const monthStartPrevious = moment([previousYear, i, 1]).startOf(
//           "month"
//         );
//         const monthEndPrevious = moment([previousYear, i, 1]).endOf("month");

//         const currentYearSales = invoices
//           ? invoices
//               .filter((inv) =>
//                 moment(inv.createdAt).isBetween(
//                   monthStartCurrent,
//                   monthEndCurrent,
//                   null,
//                   "[]"
//                 )
//               )
//               .reduce((sum, inv) => sum + (inv.total || 0), 0)
//           : 0;

//         const previousYearSales = invoices
//           ? invoices
//               .filter((inv) =>
//                 moment(inv.createdAt).isBetween(
//                   monthStartPrevious,
//                   monthEndPrevious,
//                   null,
//                   "[]"
//                 )
//               )
//               .reduce((sum, inv) => sum + (inv.total || 0), 0)
//           : 0;

//         data.push({
//           period: moment().month(i).format("MMM"),
//           [currentYear]: currentYearSales,
//           [previousYear]: previousYearSales,
//         });
//       }
//     }
//     return data;
//   }, [invoices, salesView]);

//   const formatNumber = (num) => {
//     return Number(num).toLocaleString("en-US", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });
//   };

//   const formatCurrency = (value) =>
//     `₹${Number(value).toLocaleString("en-US", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     })}`;

//   if (isLoading) {
//     return (
//       <div className={styles.loadingContainer}>
//         <Spinner />
//       </div>
//     );
//   }

//   if (!user) history.push("/login");

//   return (
//     <div className={styles.dashboard}>
//       {/* Alert Banner */}
//       {lowStockItems.length > 0 && (
//         <div className={styles.alertBanner}>
//           <span>
//             Warning: {lowStockItems.length} item
//             {lowStockItems.length > 1 ? "s are" : " is"} below minimum stock.
//           </span>
//           <Button
//             variant="contained"
//             className={styles.alertButton}
//             onClick={() => setShowLowStock(!showLowStock)}
//           >
//             {showLowStock ? "Hide" : "View List"}
//           </Button>
//         </div>
//       )}

//       {/* Collapsible Low Stock List */}
//       <Collapse in={showLowStock}>
//         <div className={styles.lowStockContainer}>
//           <h3 className={styles.lowStockTitle}>Low Stock Items</h3>
//           <Table className={styles.lowStockTable}>
//             <TableHead>
//               <TableRow>
//                 <TableCell>Item Name</TableCell>
//                 <TableCell>Current Stock</TableCell>
//                 <TableCell>Minimum Stock</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {lowStockItems.map((item) => (
//                 <TableRow key={item._id}>
//                   <TableCell>{item.name}</TableCell>
//                   <TableCell>{`${item.currentStock} ${item.unit}`}</TableCell>
//                   <TableCell>{`${item.minStock} ${item.unit}`}</TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </div>
//       </Collapse>

//       {/* Filtered Stats Section */}
//       <section className={styles.filteredStats}>
//         <div className={styles.dateFilter}>
//           <MuiPickersUtilsProvider utils={DateFnsUtils}>
//             <KeyboardDatePicker
//               label="From"
//               value={startDate}
//               onChange={handleStartDateChange}
//               format="dd/MM/yyyy"
//               maxDate={endDate || new Date()}
//               className={styles.datePicker}
//             />
//             <KeyboardDatePicker
//               label="To"
//               value={endDate}
//               onChange={handleEndDateChange}
//               format="dd/MM/yyyy"
//               minDate={startDate}
//               className={styles.datePicker}
//             />
//           </MuiPickersUtilsProvider>
//           <Button
//             variant="contained"
//             className={styles.resetButton}
//             onClick={handleResetFilters}
//             startIcon={<ReplayIcon />}
//           >
//             Reset
//           </Button>
//         </div>
//         <div className={styles.grid}>
//           <StatCard
//             values={
//               showAllSales
//                 ? [
//                     {
//                       label: "Cash Sale",
//                       value: `₹${formatNumber(todaysSales.cashSale)}`,
//                     },
//                     {
//                       label: "Online Sale",
//                       value: `₹${formatNumber(todaysSales.onlineSale)}`,
//                     },
//                     {
//                       label: "Card Sale",
//                       value: `₹${formatNumber(todaysSales.cardSale)}`,
//                     },
//                     {
//                       label: "Credit Sale",
//                       value: `₹${formatNumber(todaysSales.creditSale)}`,
//                     },
//                     {
//                       label: "Total",
//                       value: `₹${formatNumber(todaysSales.totalSale)}`,
//                       highlight: true,
//                     },
//                   ]
//                 : [
//                     {
//                       label: "Cash Sale",
//                       value: `₹${formatNumber(todaysSales.cashSale)}`,
//                     },
//                     {
//                       label: "Credit Sale",
//                       value: `₹${formatNumber(todaysSales.creditSale)}`,
//                     },
//                     {
//                       label: "Total",
//                       value: `₹${formatNumber(todaysSales.totalSale)}`,
//                       highlight: true,
//                     },
//                   ]
//             }
//             heading={isTodayFilter ? "Today's Sales" : "Total Sales"}
//             icon={<Check />}
//             link="/invoices"
//             showAll={showAllSales}
//             toggleShowAll={toggleShowAllSales}
//           />
//           <StatCard
//             values={[
//               {
//                 label: "Receipt Total",
//                 value: `₹${formatNumber(cashFlow.receiptTotal)}`,
//               },
//               {
//                 label: "Payments Total",
//                 value: `₹${formatNumber(cashFlow.paymentsTotal)}`,
//               },
//               {
//                 label: "Net Cash Flow",
//                 value: `₹${formatNumber(cashFlow.netCashFlow)}`,
//                 highlight: true,
//               },
//             ]}
//             heading="Customer Ledger"
//             icon={<Report />}
//             link="/meetings"
//           />

     

//           <StatCard
//             value={`₹${formatNumber(totalDiscount)}`}
//             heading={isTodayFilter ? "Today's Discount" : "Total Discount"}
//             icon={<Check />}
//             link="/invoices"
//             highlight
//           />  
//         </div>
//       </section>

//       {/* Other Stats Section */}
//       <section className={styles.stats}>
//         <div className={styles.grid}>
//           <StatCard
//             value={`₹${formatNumber(receivables)}`}
//             heading="Receivables"
//             icon={<Check />}
//             link="/invoices"
//             highlight
//           />
//           <StatCard
//             value={`₹${formatNumber(payables)}`}
//             heading="Payables"
//             icon={<Check />}
//             link="/purchases"
//             highlight
//           />
//           <StatCard
//             value={
//               stockValuation
//                 ? `₹${formatNumber(stockValuation)}`
//                 : "Data Not Available"
//             }
//             heading="Current Stock Valuation (FIFO)"
//             subLabel={stockValuation ? "" : "Requires item Purchase cost data"}
//             icon={<Order />}
//             link="/items"
//             highlight
//           />
//         </div>
//       </section>

//       {/* Summary Section */}
//       <section className={styles.summarySection}>
//         <div className={styles.summaryContainer}>
//           <div className={styles.chartWrapper}>
//             <h3 className={styles.chartTitle}>
//               YTD Sales Comparison ({moment().year() - 1} vs {moment().year()})
//             </h3>
//             <div className={styles.toggleButtons}>
//               <Button
//                 className={
//                   salesView === "month"
//                     ? styles.activeToggle
//                     : styles.toggleButton
//                 }
//                 onClick={() => setSalesView("month")}
//               >
//                 Monthly
//               </Button>
//             </div>
//             {ytdSalesData.length > 0 ? (
//               <BarChart
//                 width={500}
//                 height={250}
//                 data={ytdSalesData}
//                 margin={{ top: 20, right: 20, left: 40, bottom: 40 }}
//               >
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis
//                   dataKey="period"
//                   tick={{ fontSize: 12 }}
//                   angle={0}
//                   textAnchor="middle"
//                   height={40}
//                 />
//                 <YAxis
//                   tickFormatter={formatCurrency}
//                   width={60}
//                   tick={{ fontSize: 12 }}
//                 />
//                 <Tooltip
//                   formatter={formatCurrency}
//                   contentStyle={{
//                     fontSize: 12,
//                     borderRadius: "8px",
//                     background: "#fff",
//                     border: "1px solid #ddd",
//                   }}
//                 />
//                 <Legend wrapperStyle={{ paddingTop: "10px", fontSize: 12 }} />
//                 <Bar
//                   dataKey={moment().year() - 1}
//                   fill="#82ca9d"
//                   name={`${moment().year() - 1} Sales`}
//                 />
//                 <Bar
//                   dataKey={moment().year()}
//                   fill="#1976d2"
//                   name={`${moment().year()} Sales`}
//                 />
//               </BarChart>
//             ) : (
//               <div className={styles.noDataMessage}>
//                 No YTD Sales Data Available
//               </div>
//             )}
//           </div>
//           <div className={styles.sellingWrapper}>
//             <h3 className={styles.sellingTitle}>Top Selling Items</h3>
//             <table className={styles.sellingTable}>
//               <thead>
//                 <tr>
//                   <th>Item</th>
//                   <th>Count</th>
//                   <th>Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {fastSelling.map((item) => (
//                   <tr key={`${item.id}-${item.type}`}>
//                     <td>{item.name}</td>
//                     <td>{item.appearances}</td>
//                     <td className={styles.amount}>
//                       ₹{formatNumber(item.amount)}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             <h3 className={styles.sellingTitle}>Slow Selling Items</h3>
//             <table className={styles.sellingTable}>
//               <thead>
//                 <tr>
//                   <th>Item</th>
//                   <th>Count</th>
//                   <th>Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {slowSelling.map((item) => (
//                   <tr key={`${item.id}-${item.type}`}>
//                     <td>{item.name}</td>
//                     <td>{item.appearances}</td>
//                     <td className={styles.amount}>
//                       ₹{formatNumber(item.amount)}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// const StatCard = ({
//   value,
//   values,
//   heading,
//   subLabel,
//   icon,
//   link,
//   highlight,
//   showAll,
//   toggleShowAll,
// }) => {
//   return (
//     <Link to={link || "#"} className={styles.statCardLink}>
//       <div
//         className={`${styles.statCard} ${highlight ? styles.highlight : ""} ${
//           !showAll && heading.includes("Sales") ? styles.collapsed : ""
//         }`}
//       >
//         <div className={styles.statContent}>
//           <h3 className={styles.statHeading}>{heading}</h3>
//           {values ? (
//             <div className={styles.multiValueContainer}>
//               {values.length > 0 ? (
//                 values.map((val, index) => (
//                   <p
//                     key={index}
//                     className={`${styles.multiValueText} ${
//                       val.highlight ? styles.highlightValue : ""
//                     }`}
//                   >
//                     {val.label}: {val.value}
//                   </p>
//                 ))
//               ) : (
//                 <p className={styles.multiValueText}>No Data</p>
//               )}
//             </div>
//           ) : (
//             <>
//               <p
//                 className={`${styles.statValue} ${
//                   highlight ? styles.highlightValue : ""
//                 }`}
//               >
//                 {value}
//               </p>
//               {subLabel && <p className={styles.statSubLabel}>{subLabel}</p>}
//             </>
//           )}
//           {heading.includes("Sales") && (
//             <Button
//               variant="text"
//               className={styles.seeMoreButton}
//               onClick={(e) => {
//                 e.preventDefault();
//                 toggleShowAll();
//               }}
//             >
//               {showAll ? "See Less" : "See More"}
//             </Button>
//           )}
//         </div>
//         <div className={styles.statIcon}>{icon}</div>
//       </div>
//     </Link>
//   );
// };

// export default Dashboard;

import React, { useEffect, useMemo, useState, useContext } from "react";
import { toCommas } from "../../utils/utils";
import styles from "./Dashboard.module.css";
import { useHistory, useLocation, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getInvoices } from "../../actions/invoiceActions";
import { getMeetings } from "../../actions/meetingActions";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  Button,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import ReplayIcon from "@material-ui/icons/Replay";
import moment from "moment";
import { Check, Report, Order } from "./Icons";
import Spinner from "../Spinner/Spinner";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import { StockContext } from "../../Context/StockContext";
import * as api from "../../api/index";
import axios from "axios";
import { getStockAdjustments } from "../../actions/stockAdjustmentActions";

const Dashboard = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("profile"));
  const { invoices, isLoading } = useSelector((state) => state?.invoices);
  const { meetings } = useSelector((state) => state?.meetings);
  const { items } = useSelector((state) => state.items);
  const { getCurrentStockQty, getConvertedQuantity, convertPrice } =
    useContext(StockContext);
  const [lowStockItems, setLowStockItems] = useState([]);
  const [showLowStock, setShowLowStock] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [totalCreditDue, setTotalCreditDue] = useState(0);
  const [salesView, setSalesView] = useState("month");
  const [stockValuation, setStockValuation] = useState(0);
  const [showAllSales, setShowAllSales] = useState(false);
  const stockAdjustments = useSelector(
    (state) => state.stockAdjustments.stockAdjustments
  );

  // Date filter handlers
  const handleStartDateChange = (date) => {
    if (date && (!endDate || date <= endDate)) setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    if (date && (!startDate || date >= startDate)) setEndDate(date);
  };

  const handleResetFilters = () => {
    const today = new Date();
    setStartDate(today);
    setEndDate(today);
  };

  // Fetch low stock items
  useEffect(() => {
    const fetchLowStockItems = async () => {
      try {
        const { data: items } = await api.fetchItems();
        const lowStock = [];
        for (const item of items) {
          if (
            !item ||
            !item._id ||
            !item.itemName ||
            !item.stockQty?.minQty ||
            !item.toggleStock ||
            !item.isActive ||
            item.isDeleted
          ) {
            continue;
          }
          const stockData = await getCurrentStockQty(item._id);
          if (stockData && stockData.currentStock <= item.stockQty.minQty) {
            lowStock.push({
              _id: item._id,
              name: item.itemName,
              currentStock: stockData.currentStock,
              minStock: item.stockQty.minQty,
              unit: item.units?.stock?.unit?.abbreviation || "",
            });
          }
        }
        setLowStockItems(lowStock);
      } catch (error) {
        console.error("Error fetching low stock items:", error);
        setLowStockItems([]);
      }
    };
    fetchLowStockItems();
  }, [getCurrentStockQty]);

  // Fetch purchases and calculate total credit due
  useEffect(() => {
    const fetchPurchases = async () => {
      try {
        const { data: purchases } = await axios.get(
          `${process.env.REACT_APP_API}/purchases?searchQuery=${user?.result?._id}`
        );
        const creditDue = purchases
          .filter((purchase) => purchase.paymentMode === "Credit")
          .reduce((sum, purchase) => sum + (purchase.supplierDue || 0), 0);
        setTotalCreditDue(creditDue);
      } catch (error) {
        console.error("Error fetching purchases:", error);
        setTotalCreditDue(0);
      }
    };
    if (user?.result?._id) {
      fetchPurchases();
    }
  }, [user?.result?._id]);

  // Fetch invoices and meetings
  useEffect(() => {
    dispatch(getInvoices());
    dispatch(getMeetings());
    dispatch(getStockAdjustments());
  }, [location, dispatch]);

  useEffect(() => {
    const calculateStockValuation = async () => {
      try {
        const { data: allItems } = await api.fetchItems();
        const stockItems = allItems.filter(
          (item) => item.toggleStock && item.isActive && !item.isDeleted
        );

        let totalValuation = 0;

        for (const item of stockItems) {
          const stockData = await getCurrentStockQty(item._id);
          const currentStock = stockData?.currentStock || 0;

          console.log(`Item: ${item.itemName}, Current Stock: ${currentStock}`);

          if (currentStock <= 0) continue;

          // Fetch purchases
          const { data: purchases } = await axios.get(
            `${process.env.REACT_APP_API}/purchases?searchQuery=${user?.result?._id}`
          );

          console.log(`Raw purchase data for ${item.itemName}:`, purchases);

          const itemPurchases = purchases
            .filter((purchase) => {
              if (!purchase.items) return false;
              return purchase.items.some((purchaseItem) => {
                const purchaseItemId = purchaseItem.item?._id?.toString();
                return purchaseItemId === item._id.toString();
              });
            })
            .map((purchase) => ({
              date: moment(purchase.createdAt),
              items: purchase.items
                .filter(
                  (purchaseItem) =>
                    purchaseItem.item?._id?.toString() === item._id.toString()
                )
                .map((purchaseItem) => ({
                  item: purchaseItem.item,
                  quantity: parseFloat(purchaseItem.quantity || 0),
                  cost: parseFloat(purchaseItem.cost || 0),
                  providedCost: null,
                })),
              isInitial: false,
              isAdjustment: false,
            }));

          console.log(`Item Purchases for ${item.itemName}:`, itemPurchases);

          // Process stock adjustments
          const itemAdjustments = stockAdjustments
            .filter((adjustment) => {
              if (!adjustment.items) return false;
              return adjustment.items.some(
                (adjItem) => adjItem.item?.toString() === item._id.toString()
              );
            })
            .map((adjustment) => {
              const adjItem = adjustment.items.find(
                (adjItem) => adjItem.item?.toString() === item._id.toString()
              );
              const qty = parseFloat(adjItem.quantity || 0);
              const isAdd = adjustment.adjustType === "Add";
              let adjustmentCost = isAdd ? parseFloat(adjItem.cost || 0) : 0;

              // For Add adjustments, if no cost, use sale price converted to purchase unit
              if (isAdd && (!adjustmentCost || isNaN(adjustmentCost))) {
                const salePrice = parseFloat(item.units?.sale?.price || 0);
                if (salePrice > 0) {
                  const saleUnitId = String(item.units?.sale?.unit?._id);
                  const purchaseUnitId = String(
                    item.units?.purchase?.unit?._id ||
                      item.units?.stock?.unit?._id
                  );
                  adjustmentCost = convertPrice(
                    { price: salePrice, units: item.units },
                    saleUnitId,
                    purchaseUnitId
                  );
                  console.log(
                    `Adjustment (Add) for ${item.itemName}: No cost provided. Using sale price: ` +
                      `Sale Price = ${salePrice} (${saleUnitId}), ` +
                      `Converted to ${purchaseUnitId} = ${adjustmentCost}, ` +
                      `Processed as purchase`
                  );
                } else {
                  adjustmentCost = 0;
                  console.warn(
                    `Adjustment (Add) for ${item.itemName}: No cost or sale price. Setting cost to 0, Processed as purchase`
                  );
                }
              } else if (isAdd) {
                console.log(
                  `Adjustment (Add) for ${item.itemName}: Cost provided: ${adjustmentCost}, Processed as purchase`
                );
              }

              // Log provided cost for Deduct adjustments (ignored for all calculations)
              if (!isAdd && adjItem.cost) {
                console.log(
                  `Adjustment (Deduct) for ${item.itemName}: Provided cost ${adjItem.cost} recorded but ignored for valuation and deducted cost, Processed as sale`
                );
              } else if (!isAdd) {
                console.log(
                  `Adjustment (Deduct) for ${item.itemName}: No cost provided, Processed as sale with cost 0 for valuation`
                );
              }

              return {
                date: moment(adjustment.createdAt),
                items: [
                  {
                    item: { _id: item._id },
                    quantity: isAdd ? qty : -qty,
                    cost: adjustmentCost,
                    providedCost: adjItem.cost
                      ? parseFloat(adjItem.cost)
                      : null,
                  },
                ],
                isInitial: false,
                isAdjustment: true,
              };
            });

          console.log(
            `Item Adjustments for ${item.itemName}:`,
            itemAdjustments
          );

          // Calculate initial cost
          let initialCost = parseFloat(item.units?.purchase?.cost || 0);
          if (!initialCost || isNaN(initialCost)) {
            const salePrice = parseFloat(item.units?.sale?.price || 0);
            if (salePrice > 0) {
              const saleUnitId = String(item.units?.sale?.unit?._id);
              const purchaseUnitId = String(
                item.units?.purchase?.unit?._id || item.units?.stock?.unit?._id
              );
              initialCost = convertPrice(
                { price: salePrice, units: item.units },
                saleUnitId,
                purchaseUnitId
              );
              console.log(
                `Item: ${item.itemName}, No initial cost. Using sale price: ` +
                  `Sale Price = ${salePrice} (${saleUnitId}), ` +
                  `Converted to ${purchaseUnitId} = ${initialCost}, ` +
                  `Cost = ${initialCost}`
              );
            } else {
              initialCost = 0;
              console.warn(
                `Item: ${item.itemName}, No initial cost or sale price. Setting cost to 0`
              );
            }
          }

          const initialPurchase = {
            date: moment(item.createdAt),
            items: [
              {
                item: { _id: item._id },
                quantity: parseFloat(item.stockQty?.initialQty || 0),
                cost: initialCost,
                providedCost: null,
              },
            ],
            isInitial: true,
            isAdjustment: false,
          };

          const allPurchaseEntries = [
            initialPurchase,
            ...itemPurchases,
            ...itemAdjustments,
          ].sort((a, b) => {
            if (a.date.isSame(b.date)) {
              return a.isInitial ? -1 : a.isAdjustment ? 0 : 1;
            }
            return a.date.isBefore(b.date) ? -1 : 1;
          });

          console.log(
            `Sorted Purchase Entries for ${item.itemName}:`,
            allPurchaseEntries.map((entry) => ({
              date: entry.date.format("YYYY-MM-DD HH:mm:ss"),
              items: entry.items.map((item) => ({
                quantity: item.quantity,
                cost: item.cost,
                providedCost: item.providedCost,
              })),
              isInitial: entry.isInitial,
              isAdjustment: entry.isAdjustment,
            }))
          );

          const totalPurchased = allPurchaseEntries.reduce(
            (sum, entry) =>
              sum +
              entry.items.reduce(
                (s, item) => s + parseFloat(item.quantity || 0),
                0
              ),
            0
          );
          console.log(
            `Total Purchased Stock for ${item.itemName}: ${totalPurchased}`
          );

          let itemValuation = 0;
          let deductedCostTotal = 0;

          // Check for Deduct adjustments and sales
          let deductUnitsTotal = 0;
          let saleUnitsTotal = totalPurchased - currentStock;

          for (const entry of allPurchaseEntries) {
            for (const entryItem of entry.items) {
              const qty = parseFloat(entryItem.quantity || 0);
              if (qty < 0 && entry.isAdjustment) {
                deductUnitsTotal += Math.abs(qty);
              }
            }
          }

          const totalSold =
            deductUnitsTotal + (saleUnitsTotal > 0 ? saleUnitsTotal : 0);

          if (
            Math.abs(currentStock - totalPurchased) < 0.01 &&
            deductUnitsTotal === 0
          ) {
            // No sales or deductions, use all positive entries
            for (const entry of allPurchaseEntries) {
              for (const entryItem of entry.items) {
                const qty = parseFloat(entryItem.quantity || 0);
                const cost = parseFloat(entryItem.cost || 0);

                if (qty <= 0 || cost <= 0) continue;

                const value = qty * cost;
                itemValuation += value;

                console.log(
                  `Valuation for ${item.itemName} (No Sales or Deductions): Using ${qty} units @ ${cost} = ${value}, ` +
                    `From ${
                      entry.isInitial
                        ? "Initial"
                        : entry.isAdjustment
                        ? "Adjustment (Add)"
                        : "Purchase"
                    }`
                );
              }
            }
          } else {
            // Simulate FIFO removal for sales and deductions
            let remainingStock = [];
            let soldUnits = 0;
            let deductUnitsPending = deductUnitsTotal;
            let saleUnitsPending = saleUnitsTotal;

            console.log(
              `Simulating ${totalSold} units sold/deducted for ${item.itemName} (Deduct: ${deductUnitsTotal}, Sales: ${saleUnitsTotal})`
            );

            // Process positive quantities to build remainingStock in FIFO order
            for (const entry of allPurchaseEntries) {
              for (const entryItem of entry.items) {
                const qty = parseFloat(entryItem.quantity || 0);
                const cost = parseFloat(entryItem.cost || 0);
                const providedCost = entryItem.providedCost;

                if (qty === 0) continue;

                if (qty > 0) {
                  // Handle deductions first, then sales
                  let qtyToSell = 0;

                  // Deduct adjustments
                  if (deductUnitsPending > 0) {
                    const deductQty = Math.min(deductUnitsPending, qty);
                    qtyToSell += deductQty;
                    deductUnitsPending -= deductQty;
                    soldUnits += deductQty;

                    console.log(
                      `Simulating Deduction for ${
                        item.itemName
                      }: Removed ${deductQty} units @ ${cost} = ${
                        deductQty * cost
                      }, ` +
                        `Remaining in this batch: ${
                          qty - qtyToSell
                        }, Total Removed: ${soldUnits}, ` +
                        `From ${
                          entry.isInitial
                            ? "Initial"
                            : entry.isAdjustment
                            ? "Adjustment (Add)"
                            : "Purchase"
                        }`
                    );

                    deductedCostTotal += deductQty * cost;
                  }

                  // Sales
                  if (saleUnitsPending > 0 && soldUnits < totalSold) {
                    const saleQty = Math.min(saleUnitsPending, qty - qtyToSell);
                    qtyToSell += saleQty;
                    saleUnitsPending -= saleQty;
                    soldUnits += saleQty;

                    console.log(
                      `Simulating Sale for ${
                        item.itemName
                      }: Removed ${saleQty} units @ ${cost} = ${
                        saleQty * cost
                      }, ` +
                        `Remaining in this batch: ${
                          qty - qtyToSell
                        }, Total Removed: ${soldUnits}, ` +
                        `From ${
                          entry.isInitial
                            ? "Initial"
                            : entry.isAdjustment
                            ? "Adjustment (Add)"
                            : "Purchase"
                        }`
                    );

                    deductedCostTotal += saleQty * cost;
                  }

                  const qtyRemaining = qty - qtyToSell;

                  if (qtyRemaining > 0) {
                    remainingStock.push({
                      quantity: qtyRemaining,
                      cost: cost,
                      isInitial: entry.isInitial,
                      isAdjustment: entry.isAdjustment,
                    });
                  }
                } else if (qty < 0 && soldUnits < totalSold) {
                  // Deduct adjustments (already counted in deductUnitsTotal)
                  const qtyToSell = Math.min(
                    totalSold - soldUnits,
                    Math.abs(qty)
                  );
                  soldUnits += qtyToSell;
                  const qtyRemaining = Math.abs(qty) - qtyToSell;

                  // Use the cost of the earliest stock for deductions (same as sales)
                  const deductionCost = cost; // Use the cost of the stock being deducted
                  deductedCostTotal += qtyToSell * deductionCost;

                  console.log(
                    `Simulating Deduction for ${
                      item.itemName
                    }: Deducted ${qtyToSell} units @ ${deductionCost} = ${
                      qtyToSell * deductionCost
                    } (processed as sale, provided cost: ${
                      providedCost !== null ? providedCost : "none"
                    } ignored), ` +
                      `Remaining in this batch: ${qtyRemaining}, Total Removed: ${soldUnits}, ` +
                      `From Adjustment (Deduct)`
                  );

                  if (qtyRemaining > 0) {
                    remainingStock.push({
                      quantity: -qtyRemaining,
                      cost: 0,
                      isInitial: false,
                      isAdjustment: true,
                    });
                  }
                }
              }
            }

            console.log(
              `Total cost of deducted/sold stock for ${item.itemName}: ${deductedCostTotal}`
            );
            console.log(
              `Remaining Stock for ${item.itemName}:`,
              remainingStock.map((stock) => ({
                quantity: stock.quantity,
                cost: stock.cost,
                isInitial: stock.isInitial,
                isAdjustment: stock.isAdjustment,
              }))
            );

            let remainingToValue = currentStock;

            for (const stock of remainingStock) {
              const qty = parseFloat(stock.quantity || 0);
              const cost = parseFloat(stock.cost || 0);

              if (qty <= 0 || cost <= 0) continue;

              const qtyToUse = Math.min(remainingToValue, qty);
              if (qtyToUse <= 0) continue;

              const value = qtyToUse * cost;
              itemValuation += value;
              remainingToValue -= qtyToUse;

              console.log(
                `Valuation for ${item.itemName}: Using ${qtyToUse} units @ ${cost} = ${value}, ` +
                  `From ${
                    stock.isInitial
                      ? "Initial"
                      : stock.isAdjustment
                      ? "Adjustment (Add)"
                      : "Purchase"
                  }, ` +
                  `Remaining to value: ${remainingToValue}`
              );

              if (remainingToValue <= 0) break;
            }

            if (remainingToValue > 0) {
              console.warn(
                `Valuation incomplete for ${item.itemName}: ${remainingToValue} units not valued`
              );
            }
          }

          console.log(`Item: ${item.itemName}, Valuation: ${itemValuation}`);
          totalValuation += itemValuation;
        }

        console.log(`Total Valuation: ${totalValuation}`);
        setStockValuation(totalValuation);
      } catch (error) {
        console.error("Error calculating stock valuation:", error);
        setStockValuation(0);
      }
    };

    if (user?.result?._id) {
      calculateStockValuation();
    }
  }, [
    user?.result?._id,
    getCurrentStockQty,
    getConvertedQuantity,
    convertPrice,
    stockAdjustments,
  ]);


  const totalDiscount = invoices
    ? invoices
        .filter((inv) =>
          moment(inv.createdAt).isBetween(
            moment(startDate).startOf("day"),
            moment(endDate).endOf("day"),
            null,
            "[]"
          )
        )
        .reduce((sum, inv) => sum + (inv.discount || 0), 0)
    : 0;

  const today = moment().startOf("day");
  const isTodayFilter =
    moment(startDate).isSame(today, "day") &&
    moment(endDate).isSame(today, "day");

  const toggleShowAllSales = () => {
    setShowAllSales(!showAllSales);
  };

  const todaysSales = {
    cashSale: invoices
      ? invoices
          .filter(
            (inv) =>
              moment(inv.createdAt).isBetween(
                moment(startDate).startOf("day"),
                moment(endDate).endOf("day"),
                null,
                "[]"
              ) && inv.paymentMode === "Cash"
          )
          .reduce((sum, inv) => sum + (inv.total || 0), 0)
      : 0,
    onlineSale: invoices
      ? invoices
          .filter(
            (inv) =>
              moment(inv.createdAt).isBetween(
                moment(startDate).startOf("day"),
                moment(endDate).endOf("day"),
                null,
                "[]"
              ) && inv.paymentMode === "Online"
          )
          .reduce((sum, inv) => sum + (inv.total || 0), 0)
      : 0,
    cardSale: invoices
      ? invoices
          .filter(
            (inv) =>
              moment(inv.createdAt).isBetween(
                moment(startDate).startOf("day"),
                moment(endDate).endOf("day"),
                null,
                "[]"
              ) && inv.paymentMode === "Card"
          )
          .reduce((sum, inv) => sum + (inv.total || 0), 0)
      : 0,
    creditSale: invoices
      ? invoices
          .filter(
            (inv) =>
              moment(inv.createdAt).isBetween(
                moment(startDate).startOf("day"),
                moment(endDate).endOf("day"),
                null,
                "[]"
              ) && inv.paymentMode === "Credit"
          )
          .reduce((sum, inv) => sum + (inv.total || 0), 0)
      : 0,
  };
  todaysSales.totalSale =
    todaysSales.cashSale +
    todaysSales.onlineSale +
    todaysSales.cardSale +
    todaysSales.creditSale;

  const cashFlow = {
    receiptTotal: meetings
      ? meetings
          .filter(
            (meeting) =>
              moment(meeting.createdAt).isBetween(
                moment(startDate).startOf("day"),
                moment(endDate).endOf("day"),
                null,
                "[]"
              ) && meeting.transactionType === "Receipt"
          )
          .reduce((sum, meeting) => sum + (meeting.payment || 0), 0)
      : 0,
    paymentsTotal: meetings
      ? meetings
          .filter(
            (meeting) =>
              moment(meeting.createdAt).isBetween(
                moment(startDate).startOf("day"),
                moment(endDate).endOf("day"),
                null,
                "[]"
              ) && meeting.transactionType === "Payment"
          )
          .reduce((sum, meeting) => sum + (meeting.payment || 0), 0)
      : 0,
    netCashFlow:
      (meetings
        ? meetings
            .filter(
              (meeting) =>
                moment(meeting.createdAt).isBetween(
                  moment(startDate).startOf("day"),
                  moment(endDate).endOf("day"),
                  null,
                  "[]"
                ) && meeting.transactionType === "Receipt"
            )
            .reduce((sum, meeting) => sum + (meeting.payment || 0), 0)
        : 0) -
      (meetings
        ? meetings
            .filter(
              (meeting) =>
                moment(meeting.createdAt).isBetween(
                  moment(startDate).startOf("day"),
                  moment(endDate).endOf("day"),
                  null,
                  "[]"
                ) && meeting.transactionType === "Payment"
            )
            .reduce((sum, meeting) => sum + (meeting.payment || 0), 0)
        : 0),
  };

  const receivables = invoices
    ? invoices
        .filter(
          (inv) =>
            inv.paymentMode === "Credit" &&
            ["Due", "Partial"].includes(inv.status) &&
            moment(inv.createdAt).isSameOrBefore(moment(), "day")
        )
        .reduce((sum, inv) => {
          if (inv.status === "Due") {
            return sum + (inv.total || 0);
          } else if (inv.status === "Partial") {
            return sum + ((inv.total || 0) - (inv.totalAmountReceived || 0));
          }
          return sum;
        }, 0)
    : 0;

  const payables = totalCreditDue;

  const { fastSelling, slowSelling } = useMemo(() => {
    const salesMap = {};
    invoices?.forEach((invoice) => {
      if (!invoice || !invoice.items) return;
      const uniqueItems = new Set();
      invoice.items.forEach((invoiceItem) => {
        if (!invoiceItem || !invoiceItem.item || !invoiceItem.item._id) return;
        const itemId = invoiceItem.item._id;
        if (!uniqueItems.has(itemId)) {
          uniqueItems.add(itemId);
          const itemName = invoiceItem.item.itemName || "Unknown Item";
          const quantity = invoiceItem.quantity || 0;
          const price = invoiceItem.item.units?.sale?.price || 0;

          if (!salesMap[itemId]) {
            salesMap[itemId] = {
              id: itemId,
              name: itemName,
              appearances: 0,
              quantity: 0,
              amount: 0,
            };
          }
          salesMap[itemId].appearances += 1;
          salesMap[itemId].quantity += quantity;
          salesMap[itemId].amount += quantity * price;
        }
      });
    });

    const itemsArray = Object.values(salesMap);
    const fastSelling = itemsArray
      .sort((a, b) => b.appearances - a.appearances || b.quantity - b.quantity)
      .slice(0, 3)
      .map((item) => ({ ...item, type: "Fast" }));
    const slowSelling = itemsArray
      .sort((a, b) => a.appearances - b.appearances || a.quantity - b.quantity)
      .slice(0, 3)
      .map((item) => ({ ...item, type: "Slow" }));

    return { fastSelling, slowSelling };
  }, [invoices]);

  const ytdSalesData = useMemo(() => {
    const currentYear = moment().year();
    const previousYear = currentYear - 1;
    const data = [];

    if (salesView === "month") {
      const currentMonth = moment().month();
      for (let i = 0; i <= currentMonth; i++) {
        const monthStartCurrent = moment([currentYear, i, 1]).startOf("month");
        const monthEndCurrent = moment([currentYear, i, 1]).endOf("month");
        const monthStartPrevious = moment([previousYear, i, 1]).startOf(
          "month"
        );
        const monthEndPrevious = moment([previousYear, i, 1]).endOf("month");

        const currentYearSales = invoices
          ? invoices
              .filter((inv) =>
                moment(inv.createdAt).isBetween(
                  monthStartCurrent,
                  monthEndCurrent,
                  null,
                  "[]"
                )
              )
              .reduce((sum, inv) => sum + (inv.total || 0), 0)
          : 0;

        const previousYearSales = invoices
          ? invoices
              .filter((inv) =>
                moment(inv.createdAt).isBetween(
                  monthStartPrevious,
                  monthEndPrevious,
                  null,
                  "[]"
                )
              )
              .reduce((sum, inv) => sum + (inv.total || 0), 0)
          : 0;

        data.push({
          period: moment().month(i).format("MMM"),
          [currentYear]: currentYearSales,
          [previousYear]: previousYearSales,
        });
      }
    }
    return data;
  }, [invoices, salesView]);

  const formatNumber = (num) => {
    return Number(num).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatCurrency = (value) =>
    `₹${Number(value).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

  if (isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <Spinner />
      </div>
    );
  }

  if (!user) history.push("/login");

  return (
    <div className={styles.dashboard}>
      {/* Alert Banner */}
      {lowStockItems.length > 0 && (
        <div className={styles.alertBanner}>
          <span>
            Warning: {lowStockItems.length} item
            {lowStockItems.length > 1 ? "s are" : " is"} below minimum stock.
          </span>
          <Button
            variant="contained"
            className={styles.alertButton}
            onClick={() => setShowLowStock(!showLowStock)}
          >
            {showLowStock ? "Hide" : "View List"}
          </Button>
        </div>
      )}

      {/* Collapsible Low Stock List */}
      <Collapse in={showLowStock}>
        <div className={styles.lowStockContainer}>
          <h3 className={styles.lowStockTitle}>Low Stock Items</h3>
          <Table className={styles.lowStockTable}>
            <TableHead>
              <TableRow>
                <TableCell>Item Name</TableCell>
                <TableCell>Current Stock</TableCell>
                <TableCell>Minimum Stock</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {lowStockItems.map((item) => (
                <TableRow key={item._id}>
                  <TableCell>{item.name}</TableCell>
                  <TableCell>{`${item.currentStock} ${item.unit}`}</TableCell>
                  <TableCell>{`${item.minStock} ${item.unit}`}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </Collapse>

      {/* Filtered Stats Section */}
      <section className={styles.filteredStats}>
        <div className={styles.dateFilter}>
          <div className={styles.dateFilterControls}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                label="From"
                value={startDate}
                onChange={handleStartDateChange}
                format="dd/MM/yyyy"
                maxDate={endDate || new Date()}
                className={styles.datePicker}
              />
              <KeyboardDatePicker
                label="To"
                value={endDate}
                onChange={handleEndDateChange}
                format="dd/MM/yyyy"
                minDate={startDate}
                className={styles.datePicker}
              />
            </MuiPickersUtilsProvider>
            <Button
              variant="contained"
              className={styles.resetButton}
              onClick={handleResetFilters}
              startIcon={<ReplayIcon />}
            >
              Reset
            </Button>
          </div>
        </div>
        <div className={styles.grid}>
          <StatCard
            values={
              showAllSales
                ? [
                    {
                      label: "Cash Sale",
                      value: `₹${formatNumber(todaysSales.cashSale)}`,
                    },
                    {
                      label: "Online Sale",
                      value: `₹${formatNumber(todaysSales.onlineSale)}`,
                    },
                    {
                      label: "Card Sale",
                      value: `₹${formatNumber(todaysSales.cardSale)}`,
                    },
                    {
                      label: "Credit Sale",
                      value: `₹${formatNumber(todaysSales.creditSale)}`,
                    },
                    {
                      label: "Total",
                      value: `₹${formatNumber(todaysSales.totalSale)}`,
                      highlight: true,
                    },
                  ]
                : [
                    {
                      label: "Cash Sale",
                      value: `₹${formatNumber(todaysSales.cashSale)}`,
                    },
                    {
                      label: "Credit Sale",
                      value: `₹${formatNumber(todaysSales.creditSale)}`,
                    },
                    {
                      label: "Total",
                      value: `₹${formatNumber(todaysSales.totalSale)}`,
                      highlight: true,
                    },
                  ]
            }
            heading={isTodayFilter ? "Today's Sales" : "Total Sales"}
            icon={<Check />}
            link="/invoices"
            showAll={showAllSales}
            toggleShowAll={toggleShowAllSales}
            highlight={true}
          />
          <StatCard
            values={[
              {
                label: "Receipt Total",
                value: `₹${formatNumber(cashFlow.receiptTotal)}`,
              },
              {
                label: "Payments Total",
                value: `₹${formatNumber(cashFlow.paymentsTotal)}`,
              },
              {
                label: "Net Cash Flow",
                value: `₹${formatNumber(cashFlow.netCashFlow)}`,
                highlight: true,
              },
            ]}
            heading="Customer Ledger"
            icon={<Report />}
            link="/meetings"
            highlight={true}

          />
          <StatCard
            value={`₹${formatNumber(totalDiscount)}`}
            heading={isTodayFilter ? "Today's Discount" : "Total Discount"}
            icon={<Check />}
            link="/invoices"
            highlight
          />
        </div>
      </section>

      {/* General Stats Section */}
      <section className={styles.stats}>
        <div className={styles.grid}>
          <StatCard
            value={`₹${formatNumber(receivables)}`}
            heading="Receivables"
            icon={<Check />}
            link="/invoices"
            highlight
          />
          <StatCard
            value={`₹${formatNumber(payables)}`}
            heading="Payables"
            icon={<Check />}
            link="/purchases"
            highlight
          />
          <StatCard
            value={
              stockValuation
                ? `₹${formatNumber(stockValuation)}`
                : "Data Not Available"
            }
            heading="Stock Valuation (FIFO)"
            subLabel={stockValuation ? "" : "Requires item Purchase cost data"}
            icon={<Order />}
            link="/items"
            highlight
          />
        </div>
      </section>

      {/* Summary Section */}
      <section className={styles.summarySection}>
        <h3 className={styles.sectionTitle}>Sales Summary</h3>
        <div className={styles.summaryContainer}>
          <div className={styles.chartWrapper}>
            <h4 className={styles.chartTitle}>
              YTD Sales Comparison ({moment().year() - 1} vs {moment().year()})
            </h4>
            <div className={styles.toggleButtons}>
              <Button
                className={
                  salesView === "month"
                    ? styles.activeToggle
                    : styles.toggleButton
                }
                onClick={() => setSalesView("month")}
              >
                Monthly
              </Button>
            </div>
            {ytdSalesData.length > 0 ? (
              <BarChart
                width={500}
                height={250}
                data={ytdSalesData}
                margin={{ top: 20, right: 20, left: 40, bottom: 40 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="period"
                  tick={{ fontSize: 12 }}
                  angle={0}
                  textAnchor="middle"
                  height={40}
                />
                <YAxis
                  tickFormatter={formatCurrency}
                  width={60}
                  tick={{ fontSize: 12 }}
                />
                <Tooltip
                  formatter={formatCurrency}
                  contentStyle={{
                    fontSize: 12,
                    borderRadius: "8px",
                    background: "#fff",
                    border: "1px solid #ddd",
                  }}
                />
                <Legend wrapperStyle={{ paddingTop: "10px", fontSize: 12 }} />
                <Bar
                  dataKey={moment().year() - 1}
                  fill="#82ca9d"
                  name={`${moment().year() - 1} Sales`}
                />
                <Bar
                  dataKey={moment().year()}
                  fill="#1976d2"
                  name={`${moment().year()} Sales`}
                />
              </BarChart>
            ) : (
              <div className={styles.noDataMessage}>
                No YTD Sales Data Available
              </div>
            )}
          </div>
          <div className={styles.sellingWrapper}>
            <h4 className={styles.sellingTitle}>Top Selling Items</h4>
            <table className={styles.sellingTable}>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Count</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {fastSelling.map((item) => (
                  <tr key={`${item.id}-${item.type}`}>
                    <td>{item.name}</td>
                    <td>{item.appearances}</td>
                    <td className={styles.amount}>
                      ₹{formatNumber(item.amount)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <h4 className={styles.sellingTitle}>Slow Selling Items</h4>
            <table className={styles.sellingTable}>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Count</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {slowSelling.map((item) => (
                  <tr key={`${item.id}-${item.type}`}>
                    <td>{item.name}</td>
                    <td>{item.appearances}</td>
                    <td className={styles.amount}>
                      ₹{formatNumber(item.amount)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
};

const StatCard = ({
  value,
  values,
  heading,
  subLabel,
  icon,
  link,
  highlight,
  showAll,
  toggleShowAll,
}) => {
  return (
    <Link to={link || "#"} className={styles.statCardLink}>
      <div
        className={`${styles.statCard} ${highlight ? styles.highlight : ""} ${
          !showAll && heading.includes("Sales") ? styles.collapsed : ""
        }`}
      >
        <div className={styles.statContent}>
          <h3 className={styles.statHeading}>{heading}</h3>
          {values ? (
            <div className={styles.multiValueContainer}>
              {values.length > 0 ? (
                values.map((val, index) => (
                  <p
                    key={index}
                    className={`${styles.multiValueText} ${
                      val.highlight ? styles.highlightValue : ""
                    }`}
                  >
                    {val.label}: {val.value}
                  </p>
                ))
              ) : (
                <p className={styles.multiValueText}>No Data</p>
              )}
            </div>
          ) : (
            <>
              <p
                className={`${styles.statValue} ${
                  highlight ? styles.highlightValue : ""
                }`}
              >
                {value}
              </p>
              {subLabel && <p className={styles.statSubLabel}>{subLabel}</p>}
            </>
          )}
          {heading.includes("Sales") && (
            <Button
              variant="text"
              className={styles.seeMoreButton}
              onClick={(e) => {
                e.preventDefault();
                toggleShowAll();
              }}
            >
              {showAll ? "See Less" : "See More"}
            </Button>
          )}
        </div>
        <div className={styles.statIcon}>{icon}</div>
      </div>
    </Link>
  );
};

export default Dashboard;